import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import clsx from "clsx";
// The variants are separate rules rather than props-dependent values so that
// the sheet stays static: a rule with a function value gets one linked sheet
// per mounted instance, and those cannot share a class name, so the class VWO
// targets would change on every remount - see components/generateClassName.
const useStyles = makeStyles((theme) => ({
    root: {
        textAlign: "center",
        fontSize: "37px",
        fontWeight: 300,
        lineHeight: "1.1em",
        [theme.breakpoints.down("sm")]: {
            fontSize: "20px",
        },
        // Custom "break point"
        /* FIXME, not working:
        [theme.breakpoints.up(700)]: {
          fontSize: '35px'
        }*/
    },
    // Stupid with important, but desktop has overrides :/
    colorPrimary: {
        color: theme.palette.primary.dark + " !important",
    },
    colorSecondary: {
        color: theme.palette.secondary.main + " !important",
    },
    // Both spelled out, because an h1 carries margins from the user agent that
    // the disabled case has to zero rather than simply leave alone.
    margins: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(4),
    },
    noMargins: {
        marginTop: 0,
        marginBottom: 0,
    },
}));
const BoxHeading = ({ className, children, styleProps = { color: "primary", disableMargins: false }, }) => {
    const classes = useStyles();
    return (React.createElement("h1", { className: clsx(classes.root, styleProps.color === "secondary"
            ? classes.colorSecondary
            : classes.colorPrimary, styleProps.disableMargins ? classes.noMargins : classes.margins, className) }, children));
};
export default BoxHeading;
